import React from 'react';
import Hero from 'components/hero';
import FeatureCard from 'components/feature-card';
import { ReactComponent as IconControl } from 'svg/icons/control.svg';
import { ReactComponent as IconEmployee } from 'svg/icons/employee.svg';
import { ReactComponent as IconTransparent } from 'svg/icons/transparent.svg';
import { ReactComponent as Shape } from 'svg/shapes/shape_07.svg';

const WorkerIntro = () => {
  return (
    <Hero layout="grid" className="bg-secondary">
      <FeatureCard>
        <div className="icon-shape">
          <IconControl className="icon" />
          <Shape className="shape" />
        </div>
        <div className="content">
          <h3>Control</h3>
          <p>
            MyShifts believe that many agency workers want more control over
            when and who they work with, and above all how much they get paid.
          </p>
        </div>
      </FeatureCard>

      <FeatureCard>
        <div className="icon-shape">
          <IconEmployee className="icon" />
          <Shape className="shape" />
        </div>
        <div className="content">
          <h3>Transparent</h3>
          <p>
            MyShifts know that employers want to know who they are employing,
            what their skills are, and that they are getting value for money.
          </p>
        </div>
      </FeatureCard>

      <FeatureCard>
        <div className="icon-shape">
          <IconTransparent className="icon" />
          <Shape className="shape" />
        </div>
        <div className="content">
          <h3>Realistic</h3>
          <p>
            MyShifts therefore address and provide an extremely cost-effective
            way to cover vacant shifts. Become part of the &apos;
            <b>WorkeR-evolution</b>&apos;.
          </p>
        </div>
      </FeatureCard>
    </Hero>
  );
};

export default WorkerIntro;
